import React, { useState, useContext, useEffect, useRef } from 'react';
import { Grid, TextField, Tabs, Tab, Box, Typography } from '@mui/material';
import { Person, AttachMoney as AttachMoneyIcon } from '@mui/icons-material';
import { AppContext } from '../../../context/Context';
import { useTranslation } from 'react-i18next';
import SellScreenList from './SellScreenList';
import Shortcuts from './Shortcuts/Shortcuts';
import SellScreenListOKD from './SellScreenListOKD';
import SellScreenListWG from './SellScreenListWG';

function TabPanel(props) {
  const { children, value, index, ...other } = props;
  const isActive = value === index;

  return (
    <div
      role="tabpanel"
      hidden={!isActive}
      style={{ height: '100%' }}
      {...other}
    >
      {isActive && <Box sx={{ height: '100%', minHeight: 0 }}>{children}</Box>}
    </div>
  );
}

function SellScreenDescription({
  amount,
  description,
  action,
  isShortcut,
  isPayoutTicket,
  updateAmountShortcut,
  isUserSaldo,
  isRefill,
  tabValue,
}) {
  const { t } = useTranslation();
  const [isFocusedAmount, setIsFocusedAmount] = useState(false);
  const [isFocusedTicket, setIsFocusedTicket] = useState(false);

  const {
    userInfo,
    currentTicketOK,
    currentTicketWG,
    isOKBingoEnabled,
    isWGEnabled,
  } = useContext(AppContext);

  const isOKBingoEnabledRef = useRef(isOKBingoEnabled);
  useEffect(() => {
    isOKBingoEnabledRef.current = isOKBingoEnabled;
  }, [isOKBingoEnabled]);

  const isWGEnabledRef = useRef(isWGEnabled);
  useEffect(() => {
    isWGEnabledRef.current = isWGEnabled;
  }, [isWGEnabled]);

  const amountFocus = () => {
    setIsFocusedAmount(true);
    isFocusedTicket(false);
  };

  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  useEffect(() => {
    if (currentTicketWG && action === 'Utbetaling') {
      updateAmountShortcut(currentTicketWG.currentBalance);
    }
  }, [currentTicketWG]);

  useEffect(() => {
    if (currentTicketOK && action === 'Utbetaling') {
      updateAmountShortcut(currentTicketOK.amount);
    }
  }, [currentTicketOK]);

  return (
    <Grid
      container
      flexDirection="row"
      sx={{
        height: '100%',
        width: '100%',
        marginTop: 0,
        marginLeft: 0,
        justifyContent: 'center',
        alignContent: 'center',
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'row',
      }}
    >
      {/* Body description */}
      <Grid
        container
        flexDirection="row"
        sx={{
          height: '100%',
          minHeight: 0,
          width: '100%',
          alignContent: 'space-evenly',
        }}
      >
        {/*Shortcuts*/}
        {isShortcut && !isPayoutTicket && (
          <>
            <Shortcuts updateAmountShortcut={updateAmountShortcut} />
          </>
        )}

        {/*List */}
        {isPayoutTicket && !isShortcut && (
          <>
            {description !== 'OK Databingo' && description !== 'WinGames' && (
              <SellScreenList
                updateAmountShortcut={updateAmountShortcut}
                isRefill={isRefill}
              />
            )}
            {description === 'WinGames' && isWGEnabledRef.current && (
              <SellScreenListWG
                updateAmountShortcut={updateAmountShortcut}
                isRefill={isRefill}
              />
            )}
            {description === 'OK Databingo' && isOKBingoEnabledRef.current && (
              <SellScreenListOKD
                updateAmountShortcut={updateAmountShortcut}
                isRefill={isRefill}
              />
            )}
          </>
        )}

        {/*Shortcuts and list (Refill)*/}
        {isShortcut && isPayoutTicket && (
          <Box sx={{ width: '100%', height: '100%', minHeight: 0 }}>
            {tabValue === 1 ? (
              <Shortcuts
                updateAmountShortcut={updateAmountShortcut}
                isTab={true}
              />
            ) : (
              <>
                {description !== 'OK Databingo' &&
                  description !== 'WinGames' && (
                    <SellScreenList
                      updateAmountShortcut={updateAmountShortcut}
                      isTab={true}
                      isRefill={isRefill}
                    />
                  )}
                {description === 'OK Databingo' &&
                  isOKBingoEnabledRef.current && (
                    <SellScreenListOKD
                      updateAmountShortcut={updateAmountShortcut}
                      isTab={true}
                      isRefill={isRefill}
                    />
                  )}
                {description === 'WinGames' && isWGEnabledRef.current && (
                  <SellScreenListWG
                    updateAmountShortcut={updateAmountShortcut}
                    isTab={true}
                    isRefill={isRefill}
                  />
                )}
              </>
            )}
          </Box>
        )}
      </Grid>
    </Grid>
  );
}

export default SellScreenDescription;
